var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import styles from './index.css';
import auth from '../../../../../../base/auth';
import { newFaceImgList } from '../../../utils/utils';
import { postComment } from '../../../utils/api';
const text = ['文明上网，不传谣言！', '文明上网，不传谣言，登录评论！'];
class CommentTextareaBody extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            value: '',
            inserting: false,
            faceBoxShow: false,
            success: false,
            bigFaceShow: '',
            bigFace: '',
            bigFaceTitle: '',
        };
        this.handleChange = (e) => {
            const value = (e.currentTarget && e.currentTarget.value) || '';
            this.setState({
                value,
            });
        };
        this.handleFocus = () => {
            const { value } = this.state;
            const text = this.props.userInfo ? '文明上网，不传谣言！' : '文明上网，不传谣言，登录评论！';
            this.setState({
                value: value === text ? '' : value,
                inserting: true,
            });
        };
        this.handleBlur = () => {
            const { value } = this.state;
            const text = this.props.userInfo ? '文明上网，不传谣言！' : '文明上网，不传谣言，登录评论！';
            this.setState({
                value: value === '' ? text : value,
                inserting: false,
            });
        };
        this.handleFaceBoxShow = () => {
            const { faceBoxShow } = this.state;
            this.setState({ faceBoxShow: !faceBoxShow });
        };
        // 提交评论内容
        this.handleSubmit = () => {
            // 已经登录，且已经实名，则可以发表评论
            if (auth.isReal()) {
                const content = this.state.value;
                if (content === '' || text.indexOf(content) > -1) {
                    window.alert('请填写评论内容！');
                }
                else if (content.length > this.props.config.cmtLength) {
                    window.alert('评论内容过长，超过最大限制1000个字符！');
                }
                else {
                    this.postContent(content);
                }
            }
            else {
                if (auth.isLogin()) {
                    window.alert('您还没有实名认证，请先进行实名认证');
                }
                window.alert('您还没有登录，请先登录');
                auth.login(this.props.loginId);
            }
        };
        // 提交评论
        this.postContent = (content) => __awaiter(this, void 0, void 0, function* () {
            try {
                const { commentId, onSubmit } = this.props;
                const data = yield postComment(content, this.props.config, commentId);
                if (data.code === 1) {
                    this.setState({
                        value: this.props.userInfo ? '文明上网，不传谣言！' : '文明上网，不传谣言，登录评论！',
                        success: true,
                        inserting: false,
                    });
                    // 评论成功,内容显示为最初的提示语，同时显示评论成功提示
                    // 要清除定时器
                    if (this.timer) {
                        clearTimeout(this.timer);
                    }
                    this.timer = window.setTimeout(() => {
                        this.setState({
                            success: false,
                        }, () => {
                            if (onSubmit) {
                                onSubmit(content);
                            }
                        });
                    }, 1000);
                }
                else if (data.message && data.message.length > 0) {
                    window.alert(data.message);
                }
            }
            catch (e) {
                console.error(e);
            }
        });
        this.handleFaceInsert = (e) => {
            const { value } = this.state;
            const faceTitle = e.currentTarget && e.currentTarget.attributes['title'].value;
            const text = this.props.userInfo ? '文明上网，不传谣言！' : '文明上网，不传谣言，登录评论！';
            const content = `${value === text ? '' : value}[${faceTitle}]`;
            this.setState({
                value: content,
                inserting: true,
            });
        };
        this.handleMouseOver = (e) => {
            const index = Number(e.currentTarget && e.currentTarget.attributes['data-index'].value);
            const bigFace = (e.currentTarget && e.currentTarget.attributes['data-img'].value) || '';
            const bigFaceTitle = (e.currentTarget && e.currentTarget.attributes['data-title'].value) || '';
            let bigFaceShow = '';
            if ([7, 8, 9, 17, 18, 19].indexOf(index) > -1) {
                bigFaceShow = 'left';
            }
            else {
                bigFaceShow = 'right';
            }
            this.setState({
                bigFaceShow,
                bigFace,
                bigFaceTitle,
            });
        };
        this.handleMouseOut = () => {
            this.setState({
                bigFaceShow: '',
                bigFace: '',
                bigFaceTitle: '',
            });
        };
    }
    componentDidMount() {
        const text = this.props.userInfo ? '文明上网，不传谣言！' : '文明上网，不传谣言，登录评论！';
        this.setState({
            value: text,
        });
    }
    static getDerivedStateFromProps(props, state) {
        if (!state.inserting && text.indexOf(state.value) > -1) {
            return {
                value: props.userInfo ? '文明上网，不传谣言！' : '文明上网，不传谣言，登录评论！',
            };
        }
        return null;
    }
    render() {
        const { value, inserting, faceBoxShow, success, bigFaceShow, bigFace, bigFaceTitle } = this.state;
        const { headShow } = this.props;
        const stylesArr = styles;
        return (React.createElement("div", { className: styles.comment_textarea_body },
            React.createElement("div", { className: styles.textarea_box },
                React.createElement("textarea", { className: styles.comment_area, style: { color: inserting ? '#000' : '#999' }, cols: 30, rows: 10, value: value, onChange: this.handleChange.bind(this), onFocus: this.handleFocus, onBlur: this.handleBlur }),
                headShow ? React.createElement("span", { className: styles.arr_up }) : '',
                success ? React.createElement("div", { className: styles.comment_success }, "\u8BC4\u8BBA\u6210\u529F") : ''),
            React.createElement("div", { className: styles.submit_bar },
                React.createElement("a", { className: styles.submit_btn, onClick: this.handleSubmit }, "\u53D1\u8868\u8BC4\u8BBA"),
                React.createElement("div", { className: styles.comment_face_box },
                    React.createElement("div", { className: styles.comment_face },
                        React.createElement("a", { className: styles.face_trigger, onClick: this.handleFaceBoxShow },
                            React.createElement("span", { className: styles.face_btn }),
                            React.createElement("span", { className: styles.icon })),
                        faceBoxShow ? (React.createElement("div", { className: styles.face_box },
                            React.createElement("div", { className: styles.faceB },
                                React.createElement("div", { className: styles.face_list },
                                    React.createElement("span", { className: styles.arr }),
                                    React.createElement("ul", { className: styles.faceimg_list, onMouseOut: this.handleMouseOut }, newFaceImgList.map((item, index) => (React.createElement("li", { key: index, "data-index": index, "data-img": item.class, "data-title": item.title, onMouseOver: this.handleMouseOver.bind(this) },
                                        React.createElement("span", { className: stylesArr[item.class], title: item.name, onClick: this.handleFaceInsert.bind(this) }))))),
                                    bigFaceShow !== '' ? (React.createElement("div", { className: `${bigFaceShow === 'left' ? styles.big_faceL : styles.big_faceR} ${styles.big_face}` },
                                        React.createElement("span", { className: stylesArr[bigFace], title: bigFaceTitle }),
                                        React.createElement("p", null, bigFaceTitle))) : (''))))) : (''))))));
    }
}
export default CommentTextareaBody;
